<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-header">
        <div class=" d-flex justify-content-between">
          <p class="h4 mt-1">Lista de Gastos</p>
          <h6 class="text-center">
            <a class="btn btn-info text-white" (click)="createExpense()">
              Registrar Gastos
            </a>
          </h6>
        </div>
        <div class="card-body">
          <input
            class="form-control"
            #searchTerm
            (keyup)="search(searchTerm.value)"
            placeholder="Buscar gastos..."
          />
          <div *ngIf="gastos && !expenseService.isLoading">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre Usuario</th>
                  <th>Montos</th>
                  <th>Descripción</th>
                  <th>Fecha de Registro</th>
                  <!--            <th>Habilitado</th>-->
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody *ngFor="let expense of gastos.data; let i = index">
                <tr>
                  <th scope="row">{{ i + 1 }}</th>
                  <td>{{ expense.nombre_usuario }}</td>
                  <td>{{ expense.monto }}</td>
                  <td>{{ expense.descripcion }}</td>
                  <td>{{ expense.fecha }}</td>
                  <!-- <td>
            <label
              class="switch switch_type1"
              role="switch"
              *ngIf="product.habilitado == true"
            >
              <input
                type="checkbox"
                class="switch__toggle"
                (click)="enableUser(product.id)"
                checked="false"
              />
              <span class="switch__label"></span>
            </label>
            <label
              class="switch switch_type1"
              role="switch"
              *ngIf="product.habilitado == false"
            >
              <input
                type="checkbox"
                class="switch__toggle"
                (click)="enableUser(product.id)"
              />
              <span class="switch__label"></span>
            </label>
          </td>-->
                  <td>
                    <button
                      type="button"
                      class="btn btn-default "
                      (click)="editModal(expense.gasto_id)"
                    >
                      <i
                        class="fa fa-pencil-square-o text-info"
                        style="font-size: 25px"
                      ></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              Mostrando Categorías {{ gastos.from }} a {{ gastos.to }} de
              {{ gastos.total }}
            </p>
            <p>Página {{ gastos.current_page }} de {{ gastos.last_page }}</p>
            <button (click)="prevPage()" [disabled]="!gastos.prev_page_url">
              Anterior
            </button>
            <button (click)="nextPage()" [disabled]="!gastos.next_page_url">
              Siguiente
            </button>
          </div>
          <p *ngIf="expenseService.isLoading">Cargando...</p>
        </div>
      </div>
    </div>
  </div>
</div>
